<template>
  <v-layout column>
    <v-toolbar dense flat style="padding-left: 0; background: none">
      <v-toolbar-title class="pl-1 body-1">{{label}}</v-toolbar-title>
    </v-toolbar>

    <v-data-table
      class="dense"
      :headers="headers"
      :items="value"
      hide-actions
    >
      <template slot="items" slot-scope="props">
        <td>{{props.item.order}}</td>
        <td>{{props.item.name}}</td>
      </template>
    </v-data-table>
  </v-layout>
</template>
<script>
  import XOrgSelect from '@/components/global/OrgSelectForm'

  export default {
    name: 'orgsView',
    props: ['value', 'label', 'hint'],
    components: {XOrgSelect},

    data() {
      return {
        headers: [
          {text: '排序', sortable: false, value: 'rank', width: 18},
          {text: '归属单位名称', align: 'left', sortable: false, value: 'name'}
        ]
      }
    }
  }
</script>
<style>
  div.menu__content.hide-list {
    display: none;
  }
</style>

